/**
 * Translations for the music style picker (gameAudio.ts).
 */
const audio = {
  zh: {
    'audio.style.piano.label': '纯钢琴',
    'audio.style.piano.helper': '安静 · 治愈',
    'audio.style.lullaby.label': '摇篮曲',
    'audio.style.lullaby.helper': '柔软 · 入睡',
    'audio.style.lofi.label': '轻音乐',
    'audio.style.lofi.helper': '放松 · 学习',
  } as Record<string, string>,
  en: {
    'audio.style.piano.label': 'Pure piano',
    'audio.style.piano.helper': 'Quiet · soothing',
    'audio.style.lullaby.label': 'Lullaby',
    'audio.style.lullaby.helper': 'Soft · for sleep',
    'audio.style.lofi.label': 'Lo-fi',
    'audio.style.lofi.helper': 'Relax · study',
  } as Record<string, string>,
};

export default audio;
